import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { clientApi } from "./client-api";

interface ClientState {
  clients: Client[];
  selectedClient?: Client;
  areClientsLoading: boolean;
}

const initialState: ClientState = {
  clients: [],
  selectedClient: undefined,
  areClientsLoading: false,
};

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClients: (state, action: PayloadAction<ClientState["clients"]>) => {
      state.clients = action.payload;
      state.areClientsLoading = false;
    },
    clearClients: (state) => {
      state.clients = [];
    },
    setSelectedClient: (state, action: PayloadAction<Client | undefined>) => {
      state.selectedClient = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addMatcher(
      clientApi.endpoints.getAllClients.matchPending,
      (state) => {
        state.areClientsLoading = true;
      }
    );
  },
});

export const { setClients, clearClients, setSelectedClient } =
  clientSlice.actions;
